export default __webpack_public_path__ + "static/media/trash_icon.74f3f96c.svg";